import CN from '@/assets/images/widgetLogo/CN.png';
import PDD from '@/assets/images/widgetLogo/PDD.png';
import JD from '@/assets/images/widgetLogo/JD.png';
import CLODOP from '@/assets/images/widgetLogo/CLODOP.png';
import FXG from '@/assets/images/widgetLogo/FXG.png';

const state = {
  CLODOP: {
    title: 'CLODOP',
    code: 'CLODOP',
    port: {
      ws: 8000,
      wss: 8443,
    },
    icon: CLODOP,
    download: 'https://erp-qd.oss-cn-hangzhou.aliyuncs.com/print_control/CLodop_Setup_for_Win32NT.exe',
    version: '6.5.6.6',
    isMac: false,
    target: false,
  },
  CN: {
    title: '菜鸟',
    code: 'CN',
    port: {
      ws: 13528,
      wss: 13529,
    },
    icon: CN,
    download: 'https://cloudprint.cainiao.com/cloudprint/client/CNPrintSetup.exe',
    version: '',
    color: '#359aff',
    socket: false,
    isMac: true,
    target: false,
    printerList: false,
  },
  PDD: {
    title: '拼多多',
    code: 'PDD',
    port: {
      ws: 5000,
      wss: 18653,
    },
    icon: PDD,
    download: 'https://api.pinduoduo.com/api/app/v1/latest/com.xunmeng.pddprint/windows',
    version: '1.0',
    color: '#e02e24',
    socket: false,
    isMac: false,
    target: false,
    printerList: false,
  },
  JD: {
    title: '京东',
    code: 'JD',
    port: {
      ws: 9113,
      wss: 9113,
    },
    icon: JD,
    download: 'https://erp-qd.oss-cn-hangzhou.aliyuncs.com/print_control/openJDprint_setupJD%E6%89%93%E5%8D%B0%E7%BB%84%E4%BB%B6.exe',
    version: '1.0',
    color: '#e31d1c',
    socket: false,
    isMac: false,
    target: false,
    printerList: false,
  },
  FXG: {
    title: '字节（抖店）',
    code: 'FXG',
    port: {
      ws: 13888,
      wss: 13888,
    },
    icon: FXG,
    download:
      'https://sf3-ttcdn-tos.pstatp.com/obj/logistics-davinci/install/%E6%8A%96%E5%BA%97%E5%AE%98%E6%96%B9%E6%89%93%E5%8D%B0%E7%BB%84%E4%BB%B6-1.0.0.6.exe',
    version: '',
    color: '#0050ff',
    socket: false,
    isMac: true,
    target: false,
    printerList: false,
  },
  KM: {
    title: '快麦ERP打印助手',
    code: 'KM',
    port: { ws: 51541, wss: 51541 },
    download: 'https://erp-qd.oss-cn-hangzhou.aliyuncs.com/print_control/ERPPrintAssistant_Setup.exe',
    version: '1.0',
    color: '#2695FA',
    socket: false,
    isMac: false,
    target: false,
  },
  VIPMP: {
    title: '唯品会MP订单',
    code: 'VIPMP',
    port: { ws: 12233, wss: 12233 },
    download:
      'https://erp-qd.oss-cn-hangzhou.aliyuncs.com/print_control_package/%E5%94%AF%E5%93%81%E4%BC%9A%E6%89%93%E5%8D%B0%E7%BB%84%E4%BB%B6.zip',
    version: '1.0',
    color: '#f694ca',
    socket: false,
    isMac: false,
    target: false,
    printerList: false,
    isNext: true,
  },
  KS: {
    title: '快手',
    code: 'KS',
    port: { ws: 16888, wss: 16889 },
    version: '1.0',
    download: 'https://s1-11586.kwimgs.com/kos/nlav11586/printer/kuaishou-print-installer-v1.1.1.exe',
    color: '#ff4906',
    socket: false,
    isMac: false,
    target: false,
    printerList: false,
  },
  THH: {
    title: '团好货',
    code: 'THH',
    port: { ws: 28613, wss: 28613 },
    version: '1.0',
    download: 'https://s3plus.sankuai.com/v1/mss_d1fd79bf8dca4a48b89eec256ac57a5c/mtob/2.1.1/MTOB%20Setup%202.1.1.exe',
    color: '#ffcc33',
    socket: false,
    isMac: false,
    target: false,
    printerList: false,
    isNext: true,
  },
  KMBT: {
    title: 'BT打印助手',
    port: { ws: 23456, wss: 23456 },
    version: '1.0',
    download: 'https://erp-qd.oss-cn-hangzhou.aliyuncs.com/print_control/KM_BT_PRINTER_Setup.exe',
    color: '#2695fa',
    socket: false,
    isNext: true,
  },
};

const mutations = {
  UPDATE_SOCKET(state, { widgetType, socket }) {
    state[widgetType].socket = socket;
  },
  UPDATE_INFO(state, { widgetType, info }) {
    state[widgetType].info = info;
  },
  UPDATE_TARGET(state, { widgetType, target }) {
    state[widgetType].target = target;
  },
  UPDATE_PRINTER_LIST(state, { widgetType, printerList }) {
    state[widgetType].printerList = printerList;
  },
};
const actions = {
  UPDATE_SOCKET({ commit }, { widgetType, socket }) {
    // console.log('[print]UPDATE_SOCKET', widgetType, socket);
    commit('UPDATE_SOCKET', { widgetType, socket });
  },
  UPDATE_INFO({ commit }, { widgetType, info }) {
    commit('UPDATE_INFO', { widgetType, info });
  },
  UPDATE_TARGET({ commit }, { widgetType, target }) {
    commit('UPDATE_TARGET', { widgetType, target });
  },
  UPDATE_PRINTER_LIST({ commit }, { widgetType, printerList }) {
    commit('UPDATE_PRINTER_LIST', { widgetType, printerList });
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
